<script setup lang="ts">
import { SurpriseBagCard } from '@pkg/ui/components/ui/surpriseBagCard';
import type { SurpriseBag } from '@pkg/types/surpriseBag';

defineProps<{
  bags?: SurpriseBag[] | null;
  title?: string | null;
}>();
</script>

<template>
  <section v-if="bags && bags.length > 0" class="s-bags">
    <h2 v-if="title" class="s-detail__title__secondary">
      {{ title }}
    </h2>
    <div class="s-bags__grid">
      <SurpriseBagCard
        v-for="bag in bags"
        :key="bag.item.itemId"
        :article="bag"
      />
    </div>
  </section>
</template>

<style scoped>
.s-bags__grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  justify-items: center;
  width: 100%;

  @screen tablet-wide {
    grid-template-columns: repeat(2, 1fr);
  }

  @screen desk {
    grid-template-columns: repeat(3, 1fr);
  }

  @screen big-desk {
    justify-items: left;
  }
}
</style>
